<template>
    <v-autocomplete
      v-model="selected"
      ref="autocomplete"
      :loading="loading"
      :items="items"
      :search-input.sync="search"
      :multiple="multiple"
      :item-text="(item) => (`${item.name}//${item.taxonomy_id}`)"
      return-object
      hide-no-data
      cache-items
      hide-details
      v-bind="$attrs"
      :label="`Search ${rank}`">
        <template v-slot:selection="data">
          <v-chip
            v-if="!strainNameOnly"
            :selected="data.selected"
            color="teal white--text"
            class="chip--select-multi">
              <span class="tax-span"><strong>Genus</strong>: {{data.item.tax.genus || "N/A" }} </span>
              <span class="tax-span"><strong>Species</strong>: {{data.item.tax.species || "N/A" }} </span>
              <span class="tax-span"><strong>Strain</strong>: {{data.item.name }}</span>
          </v-chip>
          <template v-else>
            <span :class="{'orange--text': data.selected}">{{data.item.name }}</span>
          </template>
        </template>
        <template v-slot:item="{item}">
            <v-list-tile-content>
              <v-list-tile-title v-html="`${item.name} <em>(${item.taxonomy_id})</em>`"></v-list-tile-title>
              <v-list-tile-sub-title>
                <strong>Genus</strong>: {{item.tax.genus || "N/A"}} <strong>Species</strong>: {{item.tax.species || "N/A"}}
              </v-list-tile-sub-title>
            </v-list-tile-content>
        </template>
    </v-autocomplete>
</template>

<script>
import TaxonomyAPI from '@/api/taxonomy.js'
import _debounce from 'lodash/debounce'
import {isInt} from '@/utils/helpers.js'

export default {
  props: {
    rank: {
      type: String,
      default: 'strain'
    },
    value: {
      required: true
    },
    multiple: {
      required: false,
      default: false
    },
    strainNameOnly: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      items: [],
      loading: false,
      selected: [],
      search: ''
    }
  },
  created () {
    this.selected = this.value
    if (Array.isArray(this.value)) {
      this.items = this.value
    } else {
      this.items.push(this.value)
    }
  },
  methods: {
    getTaxonomy: _debounce(async function (val) {
      let filterParams
      // detect if this is an integer, if it is, search directly on taxonomy_id
      // otherwise we fuzzy search on name field.
      if (!isInt(val)) {
        // * for fuzzy searching appended to val
        filterParams = {
          name: {filter: 'ilike', value: `${val}*`},
          rank: {filter: 'equals', value: this.rank}
        }
      } else {
        filterParams = {
          taxonomy_id: {
            filter: 'equals',
            value: val
          }
        }
      }
      const params = {
        limit: 100
      }
      this.loading = true
      this.items = []
      const {data} = await TaxonomyAPI.getTaxFull({filterParams, params}, true)
      this.loading = false
      this.$refs['autocomplete'].cachedItems = data.concat(this.selected)
      this.items = data
    }, 500)
  },
  watch: {
    search (val) {
      val && val.trim() !== '' && this.getTaxonomy(val)
    },
    selected (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.selected = val
    }
  }
}
</script>

<style scoped>
  .tax-span {
    padding-right: 4px;
  }
</style>
